import { CountryPhone } from './phone-input.models';

export const DEFAULT_COUNTRY_ISO2 = 'CO';

export function getRegionFromNavigator(): string | null {
  if (typeof navigator === 'undefined') {
    return null;
  }
  const locale =
    navigator.language || (navigator.languages && navigator.languages[0]) || '';
  if (!locale) {
    return null;
  }
  try {
    if (typeof Intl !== 'undefined' && (Intl as { Locale?: typeof Intl.Locale }).Locale) {
      const localeObj = new (Intl as { Locale: typeof Intl.Locale }).Locale(locale);
      if (localeObj.region) {
        return localeObj.region.toUpperCase();
      }
    }
  } catch {
    // ignore
  }
  const parts = locale.split(/[-_]/);
  if (parts.length >= 2 && parts[1].length === 2) {
    return parts[1].toUpperCase();
  }
  return null;
}

export function resolveDefaultCountry(countries: CountryPhone[]): CountryPhone {
  if (!countries.length) {
    throw new Error('countries must not be empty');
  }
  const region = getRegionFromNavigator();
  if (region) {
    const fromLocale = countries.find((c) => c.iso2 === region);
    if (fromLocale) {
      return fromLocale;
    }
  }
  return countries.find((c) => c.iso2 === DEFAULT_COUNTRY_ISO2) ?? countries[0];
}
